import { BookState } from "@/store/types/book.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: BookState = {
    displayingChapter: 0,
    sliderHue: 180,
    sliderLuminance: 50,
    nOctaves: 5,
    baseHue: 180,
    attack: 1,
};

const namespaced = true;

export const BookModule: Module<BookState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}